import { useTranslation } from 'react-i18next';

import Section from '~/components/Section';

import { usePreferencesContext } from '../../_context/usePreferencesContext';
import EmptyState from './EmptyState';
import PreferenceOption from './Preference';

const Preferences = () => {
  const { subscription, publication, preferences } = usePreferencesContext();

  const { t } = useTranslation('', { keyPrefix: 'preferences' });

  if (!preferences || preferences.length === 0 || !publication.has_subscriber_preferences || !subscription) {
    return <EmptyState title={t('title')} text={t('empty_state')} />;
  }

  return (
    <Section
      title={t('title')}
      description={t('description', {
        subscriber_email: subscription.email,
      })}
    >
      <div className="flex flex-col gap-y-6">
        {preferences.map((preference) => (
          <PreferenceOption key={preference.id} preference={preference} />
        ))}
      </div>
    </Section>
  );
};

export default Preferences;
